import { jsx as a } from "@emotion/react/jsx-runtime";
import { DateInputFieldContainer as y } from "./DateInputField.styled.js";
import { StyledDateTextField as k } from "./DateRangeInputField.styled.js";
import { useDatePickerContext as x } from "../DatePickerContext.js";
import { formatDate as I } from "../helpers.js";
import { LeftElementType as R } from "../../../types/components/textinput.js";
const _ = ({
  label: o,
  placeholder: r
}) => {
  const {
    displayCalendar: n,
    setDisplayCalendar: i,
    dates: e,
    format: l,
    localeDatePicker: s,
    handleReset: d,
    isReset: m,
    error: t,
    warning: c,
    success: f,
    notice: p
  } = x(), u = () => {
    i(!n);
  }, C = I(e?.[0], s.name, l), D = m ?? !!e?.[0];
  return /* @__PURE__ */ a(y, { onClick: u, children: /* @__PURE__ */ a(k, { dataTrackId: "date_input_field", valueContainer: !0, id: "date", value: C, type: "text", label: o, placeholder: r, edit: !1, leftElement: ["fa-calendar-days"], leftElementType: R.Icon, autoComplete: "off", isReset: D, error: !!t, success: f, warning: c, onReset: d, notice: t ?? p }) });
};
export {
  _ as DateInputField
};
